/**
 * about.tsx
 * 
 * @copyright jnakaso.com
 * 
 * contents of about page
 * 
 */

import { Card, Center, ScrollArea, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";
import { storageService } from "src/services/storageService";

function InfoFile(props: any) {

    const [title, setTitle] = useState('Untitled Page');
    const [text, setText] = useState('No content found');

    useEffect(() => {
        setTitle(props.title);
        storageService.getInfoFile(props.file)
            .then((text) => setText(text))
            .catch((e) => console.error(e));
    }, [props])


    return (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
            <Card.Section>
                <Center h={60} bg="var(--mantine-color-gray-light)">
                    <Text fw={800} >{title}</Text>
                </Center>
            </Card.Section>
            <ScrollArea style={{ overflowY: "auto" }}>
                <Markdown>{text}</Markdown>
            </ScrollArea>
        </Card>
    );

}

export default InfoFile;